import { writable, type Writable } from 'svelte/store';

// Function to create a persistent store
function createPersistentStore<T>(key: string, initialValue: T): Writable<T> {
	let data: T;

	if (typeof localStorage !== 'undefined') {
		const storedValue = localStorage.getItem(key);
		data = storedValue ? JSON.parse(storedValue) : initialValue;
	} else {
		data = initialValue;
	}

	const store = writable(data);

	if (typeof localStorage !== 'undefined') {
		store.subscribe((value) => {
			localStorage.setItem(key, JSON.stringify(value));
		});
	}

	return store;
}

// Central store for all slices
const mainStore = writable<{ [key: string]: Writable<any> }>({});

// Function to register a slice in the main store
export function registerSlice<T>(key: string, initialValue: T): Writable<T> {
	const sliceStore = createPersistentStore(key, initialValue);

	mainStore.update((slices) => ({
		...slices,
		[key]: sliceStore
	}));

	return sliceStore;
}

// Function to get a slice from the main store
export function getSlice<T>(key: string): Writable<T> | undefined {
	let slice: Writable<T> | undefined;

	mainStore.subscribe((slices) => {
		slice = slices[key] as Writable<T>;
	})();

	return slice;
}
